import React, { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Box,
    Collapse,
    List,
    ListItem,
    SvgIcon,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { useBreakpoint } from 'common/hooks';

import MenuOption from './MenuOption';
import StyledListItemButton from './StyledComponents/StyledListItemButton';
import StyledListItemText from './StyledComponents/StyledListItemText';

const SubMenuOptions = ({
    Icon,
    drawerSize,
    handleDrawerToggle,
    iconId,
    listItemClassName,
    mobileOpen,
    options,
    setOpenDrawer,
    title,
}) => {
    const { pathname } = useLocation();
    const [subMenuOpen, setSubmenuOpen] = useState(false);
    const breakpoint = useBreakpoint();
    const isMobile = ['xs', 'sm'].includes(breakpoint);

    const handleOptionClick = () => {
        setSubmenuOpen((prev) => !prev);
        setOpenDrawer?.(false);
    };

    if (!Array.isArray(options) || options.length === 0) return null;

    const selected = options.some((option) => option.selected);

    return (
        <ListItem className={listItemClassName} disablePadding>
            <Box sx={{ width: '100%' }}>
                <StyledListItemButton
                    drawersize={drawerSize}
                    id={iconId || title}
                    onClick={handleOptionClick}
                    selected={selected}
                >
                    {Icon && (
                        <SvgIcon>
                            <Icon />
                        </SvgIcon>
                    )}
                    <StyledListItemText primary={title} />
                    {(drawerSize === 'normal' || isMobile) && (
                        <>
                            {subMenuOpen ? (
                                <ExpandLessIcon fontSize="inherit" />
                            ) : (
                                <ExpandMoreIcon fontSize="inherit" />
                            )}
                        </>
                    )}
                </StyledListItemButton>

                <Collapse in={subMenuOpen} timeout="auto">
                    <List
                        disablePadding
                        sx={{
                            '& .MuiListItemButton-root': {
                                minWidth: '189px',
                                visibility:
                                    drawerSize === 'small' && !isMobile
                                        ? 'hidden'
                                        : 'visible',
                            },
                            borderLeft: '1px solid rgba(121, 121, 121, 0.266)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                            ml: 3,
                            mt: 1,
                            pl: 2,
                        }}
                    >
                        {options.map((option) => {
                            if (option.visible === false) return null;
                            return (
                                <MenuOption
                                    Icon={option.Icon}
                                    disabled={option.disabled}
                                    drawerSize={drawerSize}
                                    handleDrawerToggle={handleDrawerToggle}
                                    id={option.id}
                                    key={option.to}
                                    listItemClassName={option.className}
                                    mobileOpen={mobileOpen}
                                    requiredPermissions={option.permission}
                                    selected={
                                        option.selected ||
                                        option.to === pathname
                                    }
                                    setOpenDrawer={setOpenDrawer}
                                    size="small"
                                    title={option.label}
                                    to={option.to}
                                />
                            );
                        })}
                    </List>
                </Collapse>
            </Box>
        </ListItem>
    );
};

SubMenuOptions.propTypes = {
    drawerSize: PropTypes.string,
    handleDrawerToggle: PropTypes.func,
    Icon: PropTypes.elementType,
    iconId: PropTypes.string,
    listItemClassName: PropTypes.string,
    mobileOpen: PropTypes.bool,
    options: PropTypes.array,
    setOpenDrawer: PropTypes.func,
    title: PropTypes.string,
};

export default SubMenuOptions;
